import { DateFnsI18n } from '../types';

export const dateFnsI18n: DateFnsI18n = {
  // eslint-disable-next-line @typescript-eslint/typedef
  pl: () => import('date-fns/locale/pl').then((mod) => mod.pl),
  // eslint-disable-next-line @typescript-eslint/typedef
  uk: () => import('date-fns/locale/uk').then((mod) => mod.uk)
};
